import Hero from "./Hero";
import TopThree from "./TopThree";
import Table from "./Table";
import Filter from "./Filter";
import ScoreTag from "./ScoreTag";
import BestAirlines from "./BestAirlines";
import HowScoreIsCalculated from "./HowScoreIsCalculated";
import JoinTheCommunity from "./JoinTheCommunity";
import Share from "./Share";

export { Hero, TopThree, ScoreTag, BestAirlines, HowScoreIsCalculated, Share, Table, Filter, JoinTheCommunity };
